import { render, staticRenderFns } from "./HistoryDrawPage.vue?vue&type=template&id=489754b2&scoped=true"
import script from "./HistoryDrawPage.vue?vue&type=script&lang=js"
export * from "./HistoryDrawPage.vue?vue&type=script&lang=js"
import style0 from "./HistoryDrawPage.vue?vue&type=style&index=0&id=489754b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489754b2",
  null
  
)

export default component.exports